import { createAction, props } from "@ngrx/store";

export const setDate = createAction("[Calendar] setDate", props<{ date: number }>());
